<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Invoice, ServicesOnInvoices } from '../../../modules/posApi/invoices/invoice'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zflow from '../../_common/z/zflow.svelte'

    interface ServiceRow {
        name: string
        value: number
    }

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let gridA: GridClass = null
    let gridB: GridClass = null
    let gridC: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: Invoice[] = await window.api.pos.invoices.getAll({ from, to, service: true })
        let items: ServicesOnInvoices[] = data.flatMap((invoice) => invoice.services || [])
        items = await window.api.utils.utils.assignServicesFromObject(items)
        console.log('relat.items', items)
        loadGrid(items)
        show = false
    }

    function loadGrid(items: ServicesOnInvoices[]) {
        const grouped = new Map<string, ServiceRow>()
        for (const el of items) {
            const key = el.serviceId || '-'
            let acc = grouped.get(key)
            if (!acc) {
                acc = { name: el.service?.name || '[sem serviço]', value: 0 }
                grouped.set(key, acc)
            }
            acc.value += (el.value || 0) * (el.quantity || 0)
        }
        const rows = [...grouped.values()].filter((row) => row.value !== 0).sort((a, b) => b.value - a.value)

        gridA = new GridClass()
        gridA.title = 'Curva ABC - A'
        gridB = new GridClass()
        gridB.title = 'Curva ABC - B'
        gridC = new GridClass()
        gridC.title = 'Curva ABC - C'
        for (const grid of [gridA, gridB, gridC]) {
            grid.cols.push(new GridCol({ content: 'Grupo', size: 1 }))
            grid.cols.push(new GridCol({ content: 'Serviço' }))
            grid.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2, showTotal: true }))
        }

        let pos = 0
        for (const row of rows) {
            pos++
            let grupo = 'C'
            if ((100 / rows.length) * pos <= 50) grupo = 'B'
            if ((100 / rows.length) * pos <= 20) grupo = 'A'

            let line: GridLine = new GridLine()
            line.slots.push({ content: grupo })
            line.slots.push({ content: row.name })
            line.slots.push({ content: row.value })

            if (grupo === 'A') gridA.lines.push(line)
            if (grupo === 'B') gridB.lines.push(line)
            if (grupo === 'C') gridC.lines.push(line)
        }
        console.log('relat.grids', gridA, gridB, gridC)
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <Zflow class="mt-2">
        <Grid class="h-space" grid={gridA} />
        <Grid grid={gridB} />
        <Grid grid={gridC} />
    </Zflow>
</div>
<LoadSpinner {show}></LoadSpinner>
